import styled from 'styled-components'

export const Wrapper = styled.div`
  > :first-child {
    border-radius: 12px 12px 0 0px;
  }
`

export const Header = styled.div`
  background-color: ${props => props.theme.primary};
  text-align: center;
  padding: 6px 20px;
  font-size: 24px;
  color: white;
`

export const Content = styled.div`
  > div {
    border: 1px solid ${props => props.theme.primary};
    border-top: none;
  }

  > :last-child {
    border-radius: 0 0 12px 12px;
  }
`

export const Drawer = styled.div`
  font-size: 18px;
`